export default {
    // "apiKey":"JO7shhIkpz35Ct28pcd0F7QhNjZOUZWh8xwgbwfs",
    // "baseAPI":"http://localhost:8080/api/", //"https://gp9o4hhgqg.execute-api.eu-central-1.amazonaws.com/api/",//"https://qn-sbn-sandbox-lso.roche.com/api/",
    isRelease1: false,
    userDetails: 'v1/userdetails',
    notificationDetail:'v1/notifications/local/overview',
    viewReminderLocal: 'v1/notifications/local',
    notificationReminderHelper: 'v1/notifications/local',
    contactDetails:'v1/notifications/local/details?notificationid=',
    PIOSMetadata:'v1/pios/metadata?searchstring=',
    globalNotification:'v1/notifications/local',
    contactNotification : 'v1/notifications/contact',
    setNotificationURL:'v1/notifications/local/status',
    getFeedBackDetails:'v1/notifications/contact/feedback/details',
    getSignedURLForFileUpload:'v1/notifications/local/attachment/uploadurl?Filename=',
    getSignedURLForCustomerFileUpload:'v1/notifications/local/customerattachment/uploadurl',
    documentURL:'https://gxerho0owa.execute-api.eu-central-1.amazonaws.com/eservice/v1/test?documentid=',
    downloadDocument:'v1/pios/document?documentid=',
    downloadAttachment: 'v1/notifications/local/attachment/downloadurl?',
    sendNotificationAPI:'v1/notifications/local/sendingqueue',
    resendNotificationAPI:'v1/notifications/local/resend',
    bulkResendNotificationAPI:'v1/notifications/bulkresend',
    getMessageTemplate: 'v1/template/overview?messagetype=Email',
    getReminderTemplate: 'v1/template/overview?messagetype=Reminder',
    addUpdateMessageTemplate: 'v1/template/save',
    deleteMessageTemplate: 'v1/template/disable?templateid=',
    fetchCsvReport: 'v1/notifications/account/generateaccountsummary',
    downloadEmailEvidence: 'v1/notifications/contact/evidenceReport',
    deleteDraftNotification: 'v1/notifications/delete?notificationID=',
    feedbackAckApi:'v1/notifications/lso/acknowledge',
    editAccountData: 'v1/notifications/account/edit',
    getAccountList: 'v1/notifications/account/list?notificationid=',
    getContactList: 'v1/notifications/account/contact?AccountNotificationId=',
    getRexisSapDataUrl: 'v1/contacts?',
    getRexSapPolling: 'v1/contacts/pollresults?mainTaskId=',
    getNotificationAuditTrailData: 'v1/auditrail/notifications?notificationId=',
    getContactNotificationAuditTrailData: 'v1/auditrail/contactnotifications?contactNotificationId=',
    getAccountNotificationAuditTrailData: 'v1/auditrail/accountnotifications?accountNotificationId=',
    internalNotesAPI: 'v1/notifications/lso/notes',
    generateEmailReportAPI: 'v1/notifications/generateemailreport',
    generateemailreportdetailsAPI: 'v1/notifications/generateemailreportdetails',
    generatestatisticsreportAPI: 'v1/notifications/generatestatisticsreport',
    createNotificationVersion: 'v1/notifications/version',
    createReminders: 'v1/notifications/createreminders'
}
// https://qn-sbn-sandbox-lso.roche.com/api/v1/notifications/local/sendingqueue
// "getSignedURLForFileUpload":"v1/notifications/local/attachment/uploadurl?Filename=sample.csv&NotificationId="
// "documentURL":"https://gxerho0owa.execute-api.eu-central-1.amazonaws.com/eservice/v1/test?documentid="
// https://qn-sbn-sandbox-lso.roche.com/eservice/v1/notifications/contact
// https://gxerho0owa.execute-api.eu-central-1.amazonaws.com/eservice/v1/notifications/local
// v1/notifications/local?country=
// https://qn-sbn-sandbox-lso.roche.com/api/
// https://qn-sbn-sandbox-lso.roche.com/api/v1/pios/metadata
// https://gxerho0owa.execute-api.eu-central-1.amazonaws.com/api/
